import { render, staticRenderFns } from "./IntegralNewLog.vue?vue&type=template&id=2efb89c4&scoped=true"
import script from "./IntegralNewLog.vue?vue&type=script&lang=js"
export * from "./IntegralNewLog.vue?vue&type=script&lang=js"
import style0 from "./IntegralNewLog.vue?vue&type=style&index=0&id=2efb89c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb89c4",
  null
  
)

export default component.exports